import React from 'react';
import { OnboardingTask, CustomerProgress } from '../../types';
import TaskItem from './TaskItem';

interface TaskListProps {
  tasks: OnboardingTask[];
  progress: CustomerProgress[];
  onTaskStatusChange: (taskId: string, status: CustomerProgress['status']) => void;
}

const TaskList: React.FC<TaskListProps> = ({ tasks, progress, onTaskStatusChange }) => {
  const getProgressForTask = (taskId: string): CustomerProgress | undefined => {
    return progress.find(p => p.taskId === taskId);
  };

  const groupedTasks = {
    required: tasks.filter(t => t.taskType === 'required'),
    recommended: tasks.filter(t => t.taskType === 'recommended'),
    optional: tasks.filter(t => t.taskType === 'optional'),
  };

  return (
    <div className="task-list">
      {groupedTasks.required.length > 0 && (
        <div className="task-group">
          <h3 className="task-group-title">Required Tasks</h3>
          <div className="task-items">
            {groupedTasks.required.map(task => (
              <TaskItem
                key={task.id}
                task={task}
                progress={getProgressForTask(task.id)}
                onStatusChange={onTaskStatusChange}
              />
            ))}
          </div>
        </div>
      )}

      {groupedTasks.recommended.length > 0 && (
        <div className="task-group">
          <h3 className="task-group-title">Recommended Tasks</h3>
          <div className="task-items">
            {groupedTasks.recommended.map(task => (
              <TaskItem
                key={task.id}
                task={task}
                progress={getProgressForTask(task.id)}
                onStatusChange={onTaskStatusChange}
              />
            ))}
          </div>
        </div>
      )}

      {groupedTasks.optional.length > 0 && (
        <div className="task-group">
          <h3 className="task-group-title">Optional Tasks</h3>
          <div className="task-items">
            {groupedTasks.optional.map(task => (
              <TaskItem
                key={task.id}
                task={task}
                progress={getProgressForTask(task.id)}
                onStatusChange={onTaskStatusChange}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskList;